import clsx, { type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { createTV } from "tailwind-variants";

// Teach tailwind-merge about our semantic typography tokens. Without this,
// it treats `text-caption`, `text-h1`, etc. as text-colors and dedupes them
// against `text-foreground` (last wins), silently dropping the size class.
const twMergeConfig = {
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display",
            "h1",
            "h2",
            "h3",
            "h4",
            "body",
            "body-lg",
            "body-strong",
            "body-emphasis",
            "caption",
            "caption-strong",
            "caption-emphasis",
            "tiny",
            "micro",
            "calendar-caption",
            "calendar-tiny",
            "calendar-micro",
            "metric",
            "overline",
          ],
        },
      ],
    },
  },
} as const;

const twMerge = extendTailwindMerge(twMergeConfig);

// Re-export a configured `tv` so component variants (Button, Badge, etc.)
// use the same twMerge config. Importing `tv` directly from
// `tailwind-variants` bypasses this and silently drops typography tokens.
export const tv = createTV({ twMergeConfig });

export function cx(...args: ClassValue[]) {
  return twMerge(clsx(...args));
}

// Tremor Raw focusInput [v0.0.1]

export const focusInput = [
  // base
  "focus:ring-2",
  "focus:outline-none",
  // ring color
  "focus:ring-ring/20",
  // border color
  "focus:border-ring",
];

// Tremor Raw focusRing [v0.0.1]

export const focusRing = [
  // base
  "outline outline-offset-2 outline-0 focus-visible:outline-2",
  // outline color
  "outline-ring",
];

// Tremor Raw hasErrorInput [v0.0.1]

export const hasErrorInput = [
  // base
  "ring-2",
  // border color
  "border-destructive",
  // ring color
  "ring-destructive/20",
];

// Clickable text style
export const clickableText =
  "inline-flex w-fit cursor-pointer items-center text-caption-emphasis text-primary hover:text-primary-800 md:text-body-emphasis";
